import { useMemo, useState } from 'react';
import { serviceFaviconUrl } from '../../utils/serviceFavicon';

/**
 * Domain favicon for evidence cards (LinkedIn, Facebook, Instagram, portals).
 *
 * @param {{ res?: object, url?: string, className?: string, fallback?: string }} props
 */
export default function ResultDomainFavicon({
  res = null,
  url = '',
  className = 'h-7 w-7',
  fallback = '🔎',
}) {
  const [failed, setFailed] = useState(false);
  const href = String(url || res?.url || res?.profile_url || '').trim();
  const faviconUrl = useMemo(() => serviceFaviconUrl({ url: href, domain: href }), [href]);

  if (!faviconUrl || failed) {
    return (
      <span className={`inline-flex items-center justify-center text-xl ${className}`} aria-hidden>
        {fallback}
      </span>
    );
  }

  return (
    <img
      src={faviconUrl}
      alt=""
      className={`${className} rounded-md object-contain`}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
